import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../utils/api';
import './Login.css';
import logo from '../assets/logo.png';

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await resetPassword(token, password);
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return <p>Invalid or missing reset token.</p>;
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <img src={logo} alt="Company Logo" className="nav-logo" />
            </div>
            <p className="login-subtitle">Choose a new password</p>
          </div>

          <form onSubmit={submit} className="login-form">
            {error && <div className="alert alert-error">{error}</div>}

            <input
              type="password"
              className="input"
              placeholder="New password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />

            <input
              type="password"
              className="input"
              placeholder="Confirm password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />

            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset password'}
            </button>
          </form>
        </div>

        <div className="login-background">
          <div className="bg-gradient"></div>
          <div className="bg-grid"></div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;

